// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter[data-v-bbd841c0] {\n  opacity: 0;\n}\n.fade-enter-active[data-v-bbd841c0] {\n  transition: opacity 0.3s ease;\n}\n.fade-leave-active[data-v-bbd841c0] {\n  transition: opacity 0.1s ease;\n}\n.fade-enter-from[data-v-bbd841c0],\n.fade-leave-to[data-v-bbd841c0] {\n  opacity: 100;\n}\n", ""]);
// Exports
module.exports = exports;
